import { action } from 'typesafe-actions'
import { ConcentrationActionTypes } from './types'
import { IConcentrationPicture } from '../interface'

// Search Request
export const listRequest = (searchParams:any) => action(ConcentrationActionTypes.LIST_REQUEST, searchParams)
export const listSuccess = (data: IConcentrationPicture[]) => action(ConcentrationActionTypes.LIST_SUCCESS, data)
export const listError = (errors: any) => action(ConcentrationActionTypes.LIST_ERROR, errors)
export const listClear = () => action(ConcentrationActionTypes.LIST_CLEAR)

// Select Data
export const selectData = (id: string) => action(ConcentrationActionTypes.SELECT, id)
export const selectedData = () => action(ConcentrationActionTypes.SELECTED)
export const selectedClear = () => action(ConcentrationActionTypes.CLEAR_SELECTED)

// Create
export const createRequest = (doc: IConcentrationPicture) => action(ConcentrationActionTypes.CREATE_REQUEST, doc)
export const createSuccess = (doc: IConcentrationPicture) => action(ConcentrationActionTypes.CREATE_SUCCESS, doc) // Newly created data
export const createError = (errors: any) => action(ConcentrationActionTypes.CREATE_ERROR, errors)

// // Read
// export const readRequest = (data: IConcentrationPicture) => action(ConcentrationActionTypes.READ_REQUEST, data)
// export const readSuccess = (data: IConcentrationPicture) => action(ConcentrationActionTypes.READ_SUCCESS, data)
// export const readError = (message: string) => action(ConcentrationActionTypes.READ_ERROR, message)

// Update
export const updateRequest = (keyValues: any) => action(ConcentrationActionTypes.UPDATE_REQUEST, keyValues)
export const updateSuccess = (doc: IConcentrationPicture) => action(ConcentrationActionTypes.UPDATE_SUCCESS, doc) // Updated Data
export const updateError = (errors: any) => action(ConcentrationActionTypes.UPDATE_ERROR, errors)

// Delete
export const deleteRequest = (doc: IConcentrationPicture) => action(ConcentrationActionTypes.DELETE_REQUEST, doc)
export const deleteSuccess = (id: string) => action(ConcentrationActionTypes.DELETE_SUCCESS, id)  // Return deleted concentration id to remove from state
export const deleteError = (errors: any) => action(ConcentrationActionTypes.DELETE_ERROR, errors)
